import { StoryUrlFormat } from './storyUrlCodec'

type StoryHrefInput = {
  id?: string | null
  slug?: string | null
  originalPublishedAt?: string | null
}

type StoryHrefEnvironment = {
  canonicalUrlRedirects?: boolean
}

const getLegacyStoryHref = ({ slug }: StoryHrefInput): string => (slug ? `/${slug}` : '/')

const getStoryHref = (story: StoryHrefInput, environment?: StoryHrefEnvironment): string => {
  const canonicalUrlRedirects = environment?.canonicalUrlRedirects ?? process.env.FF_CANONICAL_URL_REDIRECTS === 'true'

  if (!canonicalUrlRedirects) {
    return getLegacyStoryHref(story)
  }

  const { id, slug, originalPublishedAt } = story

  if (!id || !slug || !originalPublishedAt) {
    return getLegacyStoryHref(story)
  }

  const date = new Date(originalPublishedAt)

  if (Number.isNaN(date.getTime())) {
    return getLegacyStoryHref(story)
  }

  return StoryUrlFormat({ date, slug, id })
}

export default getStoryHref
